<template>
  <div class="project-outbox">
    <div class="project">
      <div class="title">告警配置</div>
      <div class="right">
        <el-button type="primary" @click="addProject">新增配置</el-button>
      </div>
      <div class="table-box">
        <el-table :data="tableData" style="width: 100%">
          <el-table-column type="index" width="100" fixed label="序号"> </el-table-column>
          <el-table-column prop="alarmType" label="告警类型">
          </el-table-column>
          <el-table-column prop="alarmDesc" label="告警说明"> </el-table-column>
          <el-table-column prop="alarmValue" label="告警值">
          </el-table-column>
          <el-table-column prop="isOpen" label="是否启用">
            <template slot-scope="scope">
              <span>{{scope.row.isOpen?'启用':'关闭'}}</span>
            </template>
          </el-table-column>
          <el-table-column prop="edit" label="操作" width="200">
            <template slot-scope="scope">
              <div class="btn-out-box">
                <div class="btn-box editself" title="编辑" @click="editselfHandle(scope.row)">
                  <i class="iconfont icon-bianji1"></i>
                </div>
                <el-switch v-model="scope.row.isOpen" :active-value="1" :inactive-value="0" @click.native="changeSwitch(scope)" active-color="rgba(31, 207, 138, 1)" inactive-color="rgba(195, 195, 195, 1)">
                </el-switch>
              </div>
            </template>
          </el-table-column>
        </el-table>
      </div>
      <el-dialog title="新增/编辑告警配置" :visible.sync="dialogFormVisible" :modal-append-to-body="false">
        <el-form :label-position="'right'" :rules="rules" label-width="120px" ref="ruleForm" :model="form">
          <el-form-item label="告警类型：" prop="alarmType">
            <el-input v-model.trim="form.alarmType"></el-input>
          </el-form-item>
          <el-form-item label="告警说明：" prop="alarmDesc">
            <el-input v-model.trim="form.alarmDesc"></el-input>
          </el-form-item>
          <el-form-item label="告警值：" prop="alarmValue">
            <el-input v-model.trim="form.alarmValue" @input="changeInput"></el-input>
          </el-form-item>
          <el-form-item label="是否启用：" prop="isOpen">
            <!-- <el-input v-model.trim="form.isOpen">   @click.native="changeSwitch(scope)"</el-input> -->
            <el-switch v-model="form.isOpen" :active-value="1" :inactive-value="0" active-color="rgba(31, 207, 138, 1)" :disabled="isEdit===0" inactive-color="rgba(195, 195, 195, 1)">
            </el-switch>
          </el-form-item>
        </el-form>
        <div slot="footer" class="dialog-footer">
          <el-button @click="dialogFormVisible = false">取 消</el-button>
          <el-button type="primary" @click="addProjectHandle">确 定</el-button>
        </div>
      </el-dialog>
    </div>
  </div>
</template>
<script>
import {
  Message
} from 'element-ui';
export default {
  data() {
    return {
      value: false,
      search: "",
      tableData: [],
      // 是否是编辑
      isEdit: 0,
      dialogFormVisible: false,
      form: {
        alarmValue: "",
        alarmType: "",
        alarmDesc: "",
        isOpen: "",
        id:'',
      },
      rules: {
        alarmType: [
          { required: true, message: "请输入告警类型", trigger: "blur" },
        ],
        alarmDesc: [
          { required: true, message: "请输入告警说明", trigger: "blur" },
        ],
        alarmValue: [
          { required: true, message: "请输入告警值", trigger: "blur" },
        ],
        // isOpen: [
        //   { required: true, message: "请选择是否启用", trigger: "blur" },
        // ],
      },
      currentPage: 1,
      size: 10,
      total: 0,
    };
  },
  created() {
    this.isEdit = 0;
    this.getData();
  },
  methods: {
    getData() {
      this.$http
        .post(
          "bma-distribution-service/alarmConfig/searchAlarmConfigs"
          // {
          //   currentPage: 1,
          //   alarmDesc: this.search,
          //   size: 500,
          // }
        )
        .then((res) => {
          let list = res.data;
          this.tableData = res.data;
        });
    },
    changeSwitch(scope) {
      let status = Number(scope.row.isOpen);
      this.$confirm(
        "确认" + (status === 1 ? "开启" : "关闭") + "此告警配置?",
        "提示",
        {
          confirmButtonText: "确认",
          cancelButtonText: "取消",
          type: "warning",
        }
      )
        .then(() => {
          this.sendState(status, scope);
        })
        .catch(() => {
          this.getData();
        });
    },
    sendState(status, scope) {
      this.$http
        .post("bma-distribution-service/alarmConfig/alarmConfigSwitch", {
          alarmConfigId: scope.row.id,
        })
        .then((res) => {
          Message.success("修改成功");
          this.getData();
        });
    },
    changeInput() {
      var pattern = /^[1-9][0-9]*$/; // 正整数的正则表达式
      // 不符合正整数时
      if (!pattern.test(this.form.alarmValue)) {
        // input 框绑定的内容为空
        this.form.alarmValue = "";
      }
    },
    editselfHandle(e) {
      // console.log(e);
      // this.$refs["ruleForm"].resetFields();
      // if (!scope.row.isOpen) return;
      this.$nextTick(() => {
        if (!e) {
          this.form = {};
        } else {
          this.form.alarmValue = e.alarmValue;
          this.form.alarmType = e.alarmType;
          this.form.alarmDesc = e.alarmDesc;
          this.form.isOpen = e.isOpen;
          this.form.id = e.id;
        }
        this.isEdit = 1;
        this.dialogFormVisible = true;
      });
    },
    addProject() {
      this.dialogFormVisible = true;
      this.isEdit = 0;
      this.form = {};
      this.form.isOpen = 1;
    },
    addProjectHandle() {
      let isRight = true;
      this.$refs["ruleForm"].validate((valid) => {
        if (!valid) {
          // console.log("error submit!!");
          isRight = false;
          return false;
        }
      });
      if (!isRight) {
        return;
      }
      // let data=this.form
      delete this.form.createTime;
      delete this.form.updateTime;
      delete this.form.isAllProject;
      delete this.form.containProjects;
      // delete this.form.updateTime
      // delete this.form.isAllProject
      let urlList = [
        { url: "bma-distribution-service/alarmConfig/addAlarmConfig" },
        { url: "bma-distribution-service/alarmConfig/updateAlarmConfig" },
      ];
      this.$http.post(urlList[this.isEdit].url, this.form).then((res) => {
        if (res.code == 200) {
          Message({
            message: res.data,
            type: "success",
          });
          this.dialogFormVisible = false;
          this.getData();
        }
      });
    },
    searchHandle() {
      this.getData();
    },
  },
  watch: {
    dialogFormVisible(v) {
      if (v === false) {
          this.form = {
            alarmValue: "",
            alarmType: "",
            alarmDesc: "",
            isOpen: "",
          },
        this.$refs["ruleForm"].resetFields();
        // })
      }
    },
  },
};
</script>
<style lang="less" scoped>
.project-outbox {
  padding: 20px;
}
.project {
  background: #f8f8f9;
  border-radius: 7px;
  padding: 24px;
  .title {
    font-size: 18px;
    color: #0e223d;
    letter-spacing: 2px;
    font-weight: 600;
    text-align: left;
    width: 30%;
    display: inline-block;
    margin: 30px 0px;
  }

  .right {
    z-index: 2000;
    position: absolute;
    right: 100px;
    top: 110px;
  }
  .table-box {
    /deep/.el-table {
      background: rgba(0, 0, 0, 0);
      th,
      tr {
        background: rgba(0, 0, 0, 0);
      }
      th {
        > .cell {
          color: #152139;
          font-size: 14px;
          font-weight: 600;
          text-align: center;
        }
      }
      tr {
        td {
          text-align: center;
          font-size: 14px;
          color: #152139;
        }
      }
      .btn-out-box {
        display: flex;
        justify-content: space-around;
      }
      .btn-box {
        width: 24px;
        height: 24px;
        background: rgba(165, 165, 165, 0.1);
        border-radius: 50%;
        display: flex;
        align-items: center;
        justify-content: center;
        cursor: pointer;
        .iconfont {
          font-size: 12px;
          color: rgba(195, 195, 195, 1);
        }
        &.download.active {
          background: rgba(31, 207, 138, 0.1);
          .iconfont {
            color: rgba(31, 207, 138, 1);
          }
        }
        &.editself:hover {
          background: rgba(20, 96, 224, 0.1);
          .iconfont {
            color: rgba(20, 96, 224, 1);
          }
        }
      }
    }
    .el-switch {
      transform-origin: center;
      transform: scale(0.7);
    }
  }
  .pagination-info {
    display: flex;
    justify-content: space-between;
    align-items: center;
    margin-top: 10px;
    .left {
      font-size: 12px;
      color: rgba(137, 146, 159, 1);
    }
  }
  .el-pagination {
    text-align: center;
    margin-top: 30px;
  }
  .el-dialog {
    width: 35%;
    .el-dialog__title {
      font-weight: 600;
    }
    .el-input {
      // width: 323px;
    }
    .line {
      text-align: center;
    }
  }
}
</style>
